import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import Select from '../../FormFields/Select';
import styles from './SubAreaSelect.styles';
import SubAreaOptions from '../SubAreaOptions';
const useStyles = makeStyles(styles);

const SubAreaSelect = ({ layer, onChange }) => {
  const classes = useStyles();
  const sketchSubAreaOption = layer['sketchSubAreaId']
    ? layer.layerOption.subArea.find(sub => sub.sketchSubAreaId === layer['sketchSubAreaId'])
    : null;
  return (
    <React.Fragment>
      <Select
        label={'SubArea Select'}
        optionValueKey={'sketchSubAreaId'}
        optionLabelKey={'name'}
        options={layer.layerOption.subArea}
        value={layer['sketchSubAreaId']}
        onChange={val => onChange(layer.id, 'sketchSubAreaId', val)}
        style={{ maginTop: 15 }}
      />
      {sketchSubAreaOption && sketchSubAreaOption.options && sketchSubAreaOption.options.length ? (
        <SubAreaOptions layer={layer} options={sketchSubAreaOption.options} onChange={onChange} />
      ) : null}
    </React.Fragment>
  );
};
SubAreaSelect.defaultProps = {};
SubAreaSelect.propTypes = {
  prop: PropTypes.string,
};

export default SubAreaSelect;
